import { render, staticRenderFns } from "./consulta_articulos_por_modelo.vue?vue&type=template&id=b33376ee&"
import script from "./consulta_articulos_por_modelo.vue?vue&type=script&lang=js&"
export * from "./consulta_articulos_por_modelo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports